<template>
  <div id="app" :class="_isMobile()?'':'test'">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",
  mounted() {
    //注意route和router区别
    // console.log(this.$route);
    // console.log(this.$router);
    if (this._isMobile()) {
      console.log("手机端");
      // this.$router.replace("/m_home");
      //如果url中包含pc_detail的话
      console.log(this.$route.path);
      if (this.$route.path.indexOf("/pc_detail") != -1) {
        console.log(this.$route.path.slice(10, 30));
        let newUrl = "/m_detail" + this.$route.path.slice(10, 20);
        console.log(newUrl);
        this.$router.replace(newUrl);
      }
      if (
        this.$route.path == "/" ||
        this.$route.path == "/PC_home" ||
        this.$route.path == "/pc_home" ||
        this.$route.path == "/pc_obj" ||
        this.$route.path == "/pc_search"
      ) {
        this.$router.replace("/m_home");
      }
    } else {
      console.log("PC端");
      //如果url中包含m_detail的话
      if (this.$route.path.indexOf("/m_detail") != -1) {
        console.log(this.$route.path.slice(9, 30));
        let newUrl = "/pc_detail" + this.$route.path.slice(9, 20);
        console.log(newUrl);
        this.$router.replace(newUrl);
      }
      console.log(this.$route.path);
      if (
        this.$route.path == "/" ||
        this.$route.path == "/m_home" ||
        this.$route.path == "/m_menu" ||
        this.$route.path == "/m_oopList" ||
        this.$route.path == "/m_ooplist" ||
        this.$route.path == "/m_search"
      ) {
        this.$router.replace("/PC_home");
      }
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
};
</script>

<style>
body {
  background: #F6F9FF;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
}
.test {
  width: 1920px;
  height: 1080px;
  
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
